import { Drawer } from "melco-ui";
import { Drawer as DrawerType } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { FontReferencesList } from "./FontReferencesList";

type FontReferencesDrawerProps = {
  drawer: DrawerType;
  id: string;
};

export const FontReferencesDrawer: React.FC<FontReferencesDrawerProps> = ({
  drawer,
  id: fontId,
}) => {
  const { t } = useTranslation();
  const { closeDrawer, isDrawerOpen } = drawer;

  return (
    <Drawer
      title={t("fonts.actions.references.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
    >
      <FontReferencesList fontId={fontId} />
    </Drawer>
  );
};
